import { Loader } from 'google-maps'
import memoize from 'lodash/memoize'

export const loadGoogleApis = memoize(() => {
  return new Loader(window.googleApisKey, {
    libraries: ['places'],
  }).load()
})
